"use strict";

var Web3 = require('web3');

var util = require('../util');
/**
 * Softwallet type
 */


var Keystore = {};

Keystore.recover = function (input, password, callback) {
  var web3 = new Web3();

  try {
    var wallet = web3.eth.accounts.wallet.decrypt([input], password);
    if (!wallet || !wallet[0]) return callback(null);
    var _wallet$ = wallet[0],
        address = _wallet$.address,
        privateKey = _wallet$.privateKey;
    return callback({
      address: address.toLowerCase(),
      privateKey: util.unpadHex(privateKey)
    });
  } catch (er) {
    return callback(null);
  }
};

module.exports = Keystore;